import { AlertsConfig } from '../alerts-config.model';

export const ALERTS_CONFIG: AlertsConfig = {
    url: 'do/alerts',
    intervalTimeout: 30000,
    bellTimeout: 4000,
    toastTimeout: 8000,
    notificationTimeout: 40000
};
